var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 19.6875H17.7187V18.375H19.6875V17.0625H17.7187V14.6213L13.0265 13.0594L11.2678 14.2341C9.42102 13.1986 7.89 11.6812 6.8381 9.84375L7.96028 8.72156L6.39841 3.28125H1.31247V3.9375C1.30162 6.00856 1.7021 8.06117 2.49067 9.97626C3.27923 11.8913 4.4402 13.6308 5.90622 15.0938C7.36916 16.5598 9.10862 17.7207 11.0237 18.5093C12.9388 19.2979 14.9914 19.6983 17.0625 19.6875Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 1.3125C14.1852 1.3125 13.297 1.58192 12.5416 2.08669C11.7862 2.59145 11.1974 3.3089 10.8497 4.1483C10.502 4.9877 10.411 5.91135 10.5883 6.80245C10.7655 7.69355 11.203 8.51207 11.8455 9.15452C12.4879 9.79697 13.3065 10.2345 14.1976 10.4117C15.0887 10.589 16.0123 10.498 16.8517 10.1503C17.6911 9.80263 18.4085 9.21384 18.9133 8.4584C19.4181 7.70296 19.6875 6.81481 19.6875 5.90625C19.6875 4.68791 19.2035 3.51947 18.342 2.65798C17.4805 1.79648 16.3121 1.3125 15.0938 1.3125ZM15.75 6.17531V7.875H14.4375V5.63719L15.9403 4.13438L16.8656 5.05969L15.75 6.17531Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBackIcon);
export default __webpack_public_path__ + "static/media/CallBackIcon.6f752ad1254ec2e496fe76103943a84f.svg";
export { ForwardRef as ReactComponent };